import {
    http,
} from '../services';

class AssinaturaService {

    assinaturaForm() {
        return http.get('/assinaturas/form');
    }

    async getAssinaturas(subevento) {
        return http.get('/assinaturas', {
            subevento,
        });
    }

    async getAssinaturasDoSubEvento(assinatura) {
        return this.getAll({
            pageIndex: 1,
            rowsPerPage: 5,
            columnSort: 1,
            orderSort: 'ASC',
            searchIndex: 1,
            searchText: assinatura,
            searchOperator: 'LIKE',
        });
    }

    getAssinatura(codigo) {
        return http.get(`/assinaturas/${codigo}`);
    }

    save(assinatura) {
        return http.post('/assinaturas', assinatura);
    }

    update(assinatura) {
        return http.put('/assinaturas', assinatura);
    }

    delete(assinatura) {
        return http.delete('/assinaturas', assinatura);
    }
}

const assinaturaService = new AssinaturaService();
export default assinaturaService;